<template>
    <div>
        <div class="footer" v-if="show">
            <div class="box" v-for='(item,index) of newitems' :key = "index" :class='[item.cls,{on:index === idx}]'  @click.stop="change(item.push,index)">
                <div >
                    <img v-bind:src="'../static/images/caidan/'+item.icon+item.icon_unclick+'.png '">
                </div>
                <p :class="['colorChange',{on:index===idx}]" >{{item.name}}</p>
                <!--:class="item.icon"-->
            </div>
        </div>
        <div class="menuUp" v-bind:class="{am:isAnim}">
        <ul class = "ul_S" >
            <div class="box" v-for='(item,index) of newitems_up' :key = "index" :class='[item.cls,{on:index === idx}]'  @click.stop="change_up(item.push,index)">
                <div >
                    <img v-bind:src="'../static/images/caidan/'+item.icon+item.icon_unclick+'.png '">
                </div>
                <p >{{item.name}}</p>
                <!--:class="item.icon"-->
            </div>
        </ul>
        </div>

<!--        <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
                <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
                <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
                <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
            </el-tabs>
        </div>-->
    </div>

</template>

<script type="text/javascript">
    export default{
        name: 'bottomnav',
        // props:['idx'],
        data(){
            return {
                activeName: 'second',
                drawer: true,
                direction: 'btt',
                show:true,
                idx:0,
                isAnim: false,
                items:[
                {
                    cls:"sand",
                    name:"三维沙盘",
                    icon_unclick:2,
                    push:"/sand",
                    icon:"1-WSP"
                },
                {
                    cls:"Massif",
                    name:"建筑单体",
                    icon_unclick:1,
                    push:"/Massif",
                    icon:"7-DT",
                },
                {
                    cls:"hardcover",
                    name:"样板间VR",
                    icon_unclick:1,
                    push:"/hardcover",
                    icon:"4-JZ"
                },
                {
                    cls:"roam",
                    name:"园林漫游",
                    icon_unclick:1,
                    push:"/roam",
                    icon:"3-JG"
                },
                {
                     cls:"user",
                     name:"更多",
                     icon_unclick:1,
                     push:"/user",
                     icon:'5-GD'
                },
                {
                    cls:"Distribution",
                    name:"户型鉴赏",
                    icon_unclick:1,
                    push:"/Distribution",
                    icon:"6-HX"
                },
                {
                    cls:"Location",
                    name:"区位交通",
                    icon_unclick:1,
                    push:"/Location",
                    icon:"2-jt"
                },
                {
                    cls:"Brand",
                    name:"电子楼书",
                    icon_unclick:1,
                    push:"/Brand",
                    icon:"8-PP",
                },
                ]
            }
        },
        mounted(){

          this.items.forEach((e,i)=>{
              if (this.$route.path===e.push){
                  this.idx=i
              }
            });
        var paths=['/sand','/location','/roam','/hardcover','/user','/Distribution','/Brand','/Massif'];
        if (paths.indexOf(this.$route.path)>-1){
            this.show=true
        }else {
            //this.show=false
        }
        },
        watch:{
            $route(to,from){
                var paths=['/sand','/location','/roam','/hardcover','/user','/Distribution','/Brand','/Massif'];
                if (paths.indexOf(to.path)>-1){
                    this.show=true
                }else {
                    //this.show=false
                }
            }
        },
        computed: {
            newitems: function () {
                return this.items.filter(function (items,index) {
                    return index <= 4;
                })
            },
            newitems_up: function () {
                return this.items.filter(function (items,index) {
                    return index > 4;
                })
            }
        },
        methods:{
            // drag:function(event){    //接收事件对象
            //     dom = event.currentTarget;
            // },
            startbottom() {
                this.isAnim = !this.isAnim
                /*console.log("item")*/
            },
            change_up(push,index){

               /* var arr = this.items[3];
                this.items[3]=this.items[index+5];
                console.log(arr);
                console.log(this.items[index+5]);
                this.items[index+4] = arr;*/

               /*用Splice才能触发重新计算数值*/
                var arr = this.items.splice(3,1,this.items[index+5])[0];
                /*console.log(this.items[index+5]);*/
                this.items.splice([index+5],1,arr);
/*              this.newitems = this.items.filter(function(items,index) {
                    return index <= 4;
                });
                this.newitems_up = this.items.filter(function(items,index) {
                    return index > 4;
                });*/
                /*console.log(this.newitems);*/

                //this.$router.push(push);
                this.$router.push({
                    path: push,
                    query: {
                        hxTo:false,
                        ID_visible: true
                    }
                });
                this.isAnim =false;

                this.idx=3;

                this.newitems[3].icon_unclick=2;

            },

            change(push,index){
                if(index==4) {
                    this.$router.push({
                        query: {
                            hxTo:false,
                            ID_visible: false
                        }
                    });
                    this.startbottom();
                }
                else {
                    this.$router.push({
                        path: push,
                        query: {
                            hxTo:false,
                            ID_visible: true
                        }
                    });
                    console.log(this.$router);
                    this.isAnim =false;
                }
                this.idx=index;

                for (var i=0;i<this.items.length;i++) {
                    if(i==index){
                        this.items[i].icon_unclick=2;
                }else{
                        this.items[i].icon_unclick=1;
                    }

                }
            }
        }

    }

</script>
<style lang="scss" scoped>
    .footer{
        /*border-radius: 8px;*/
        display: flex; justify-content: space-between;
        position: absolute;
        left: 0;
        bottom:-4px;
        padding:4px 20px 8px 20px;
        /*background: url("../../static/images/caidan/dt.png")no-repeat;*/
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        width: 100%;
        height:60px;
        z-index:99;
    }
   .box{
       cursor: pointer;
       flex: 1;
       margin: auto;
       /*padding:4px 20px 8px 20px;*/
/*       width: 20%;*/
       height: 100%;
       font-size: 1.2rem;
       color: #555454;
       text-align: center;
       -webkit-user-select: none;
       -moz-user-select: none;
       -ms-user-select: none;
       user-select: none;
       -webkit-tap-highlight-color: transparent;
    }

   img{
       width: 100%;
   }
    .box>div{
        margin: 0 auto 6px auto; width: 20px; height: 20px;
        font-size: 20px;
    }
    div p{
        color: #ffffff;
        font-size:12px;
        font-family: "微软雅黑";
    }
    .on{
        color:#edc789;
    }
    .menuUp {
        position: fixed;
        bottom: -60px;
        width: 100%;
        text-align: center;
        z-index:10;
        transition:bottom 1s;
        -webkit-transition:bottom 1s; /* Safari */
    }
    .ul_S {
        border-radius: 8px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        /*position: absolute;*/
        /*left:0;*/
        -moz-opacity:0.0;
        -khtml-opacity: 0.0;
        opacity: 1.0;
        /*padding: 10px;*/
       /* margin-bottom:-10px;*/
        width: 55%;
        background-color: rgba(31, 21, 5, 0.80);
        background-size: 100%;
        bottom:155px;
        height:50px;
/*        transition:opacity 1s;
        -webkit-transition:opacity 1s; !* Safari *!*/
    }
    .am{
        bottom: 58px;
        /*height:100px;*/
        /*-moz-opacity:1.0;
        -khtml-opacity: 1.0;
        opacity: 1.0;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue